<template>
  <CreateMachineUserModal
    v-if="show"
    :loading="loading"
    :navigation-level="navigationLevel"
    :navigation-parent-id="parentId"
    @close="emit('close')"
    @create="onCreateMachineUser"
  />

  <MachineUserSecretModal
    v-if="machineUserForSecret"
    :user="machineUserForSecret"
    @close="machineUserForSecret = undefined"
  />
</template>

<script setup lang="ts">
import { CreateMachineUser, User, UserLevel } from '@infuse/iam/user/type';
import { ref } from 'vue';
import CreateMachineUserModal from './CreateMachineUserModal.vue';
import MachineUserSecretModal from './MachineUserSecretModal.vue';

const props = withDefaults(
  defineProps<{
    show: boolean;
    create: (vars: { parentId?: string; user: CreateMachineUser }) => Promise<User>;
    parentId?: string;
    navigationLevel?: UserLevel;
    loading?: boolean;
  }>(),
  {
    parentId: undefined,
    navigationLevel: UserLevel.DOMAIN,
    loading: false
  }
);

interface Emits {
  (event: 'close'): void;
  (event: 'created'): void;
}

const emit = defineEmits<Emits>();

const machineUserForSecret = ref<User | undefined>(undefined);

async function onCreateMachineUser(vars: { user: CreateMachineUser }): Promise<void> {
  const created = await props.create({ parentId: props.parentId, user: vars.user });
  emit('close');
  if (created?.secret) {
    machineUserForSecret.value = created;
  }
  emit('created');
}
</script>
